export default {
  transactionHistory: [],
  transactions: [],
  availableFunds: 0,
  currentPlan: null,
}